import { useState } from "react";
import logo from "../../../assets/images/logo.png";


const LoginFormLS = ({
  onSignIn,
  onSendOTP,
  isLoading,
  errorMessage,
  successMessage,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleSignInClick = () => {
    if (email && password) {
      onSignIn(email, password, rememberMe);
    }
  };

  const handleSendOTP = () => {
    if (forgotEmail) {
      setResetSent(true);
      onSendOTP(forgotEmail);
    }
  };

  return (
    <div className="[perspective:1000px] w-[420px]">
      <div
        className={`relative transition-transform duration-700 [transform-style:preserve-3d] ${
          isFlipped ? "[transform:rotateY(180deg)]" : ""
        }`}
      >
        
        <div className="bg-primary-dark rounded-2xl shadow-2xl w-[420px] p-10 [backface-visibility:hidden]">
          <div className="relative z-10 mb-8 animate-fade-in-up">
            <div className="flex items-center justify-center gap-3 mb-4">
              <img
                src={logo}
                alt="Cloud Icon"
                className="w-16 h-16 "
              />
              <div className="text-white text-4xl font-bold leading-tight">
                Sindi<span className="text-primary-cyan">Board</span>
              </div>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-white mb-2 tracking-tight">
            Welcome Back
          </h2>
          <p className="text-gray-300 text-sm mb-8 tracking-wide">
            ENTER YOUR CREDENTIALS HERE
          </p>

          {errorMessage && (
            <div className="bg-red-500/20 border border-red-500 rounded-xl p-3 mb-5">
              <p className="text-red-400 text-sm text-center font-medium">
                {errorMessage}
              </p>
            </div>
          )}

          <label className="block text-gray-100 text-xs font-semibold uppercase tracking-wider mb-2">
            EMAIL ADDRESS
          </label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-primary-dark border border-gray-400 rounded-xl px-4 py-3 text-white text-sm mb-5 focus:border-primary-cyan focus:outline-none focus:ring-1 focus:ring-primary-cyan transition-all duration-200"
            placeholder="name@company.com"
            type="email"
            disabled={isLoading}
          />

          <label className="block text-gray-100 text-xs font-semibold uppercase tracking-wider mb-2">
            PASSWORD
          </label>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-primary-dark border border-gray-400 rounded-xl px-4 py-3 text-white text-sm mb-5 focus:border-primary-cyan focus:outline-none focus:ring-1 focus:ring-primary-cyan transition-all duration-200"
            placeholder="********"
            type="password"
            disabled={isLoading}
          />

          <div className="flex justify-between items-center mb-8">
            <label className="flex items-center text-gray-400 text-sm cursor-pointer group">
              <input
                onChange={(e) => setRememberMe(e.target.checked)}
                type="checkbox"
                className="w-4 h-4 mr-2 rounded border-border-color bg-primary-dark text-primary-cyan focus:ring-primary-cyan focus:ring-offset-0 cursor-pointer"
              />
              <span className="group-hover:text-white transition-colors">
                Remember me
              </span>
            </label>
            <button
              type="button"
              onClick={() => setIsFlipped(true)}
              className="text-primary-cyan text-sm hover:text-primary-cyan/80 hover:underline transition-all bg-transparent border-none cursor-pointer p-0"
            >
              Forgot password?
            </button>
          </div>

          <button
            onClick={handleSignInClick}
            disabled={isLoading}
            className="w-full bg-primary-cyan text-white font-semibold py-3 rounded-xl mb-6 hover:opacity-90 hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Loading..." : "Sign In"}
          </button>
        </div>

        <div className="absolute top-0 left-0 w-full bg-primary-dark rounded-2xl shadow-2xl p-10 [backface-visibility:hidden] [transform:rotateY(180deg)]">
          <h2 className="text-3xl font-bold text-white mb-2 tracking-tight">
            Forgot Password
          </h2>
          <p className="text-gray-300 text-sm mb-8 tracking-wide">
            Enter your email to receive an OTP code
          </p>

          {errorMessage && (
            <div className="bg-red-500/20 border border-red-500 rounded-xl p-3 mb-4">
              <p className="text-red-400 text-sm text-center">{errorMessage}</p>
            </div>
          )}

          {successMessage && (
            <div className="bg-green-500/20 border border-green-500 rounded-xl p-3 mb-4">
              <p className="text-green-400 text-sm text-center">
                {successMessage}
              </p>
            </div>
          )}

          <label className="block text-gray-100 text-xs font-semibold uppercase tracking-wider mb-2">
            EMAIL ADDRESS
          </label>
          <input
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
            className="w-full bg-primary-dark border border-gray-400 rounded-xl px-4 py-3 text-white text-sm mb-8 focus:border-primary-cyan focus:outline-none focus:ring-1 focus:ring-primary-cyan transition-all duration-200"
            placeholder="name@company.com"
            type="email"
            disabled={isLoading}
          />

          {resetSent ? (
            <div className="bg-green-500/20 border border-green-500 rounded-xl p-3 mb-6">
              <p className="text-green-400 text-sm text-center">
                ✓ OTP sent! Check your email and enter the code in the modal.
              </p>
            </div>
          ) : (
            <button
              onClick={handleSendOTP}
              disabled={isLoading || !forgotEmail}
              className="w-full bg-primary-cyan text-primary-dark font-semibold py-3 rounded-xl mb-4 hover:opacity-90 hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Sending..." : "Send OTP Code"}
            </button>
          )}

          <button
            onClick={() => {
              setIsFlipped(false);
              setForgotEmail("");
              setResetSent(false);
            }}
            className="w-full bg-transparent border border-border-color text-gray-300 font-semibold py-3 rounded-xl hover:border-primary-cyan hover:text-white transition-all duration-200"
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginFormLS;